module.exports = __webpack_public_path__ + "img/error_image.3597262.svg";